<template>
  <div class="login-area" style="overflow: hidden">
    <Info v-if="isLogin" />
    <div v-else-if="$store.state.isWaitLogout" class="is-logout">
      <i class="icon-loading"></i>
      <p>登出中，请稍候</p>
    </div>
    <Login v-else @show="reportShow" />
  </div>
</template>

<script>
import Login from '../../logic-common/Login'
import Info from './Info'
export default {
  components: {
    Login,
    Info
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin
    }
  },
  methods: {
    reportShow() {
      this.$xlaPush('home_page_login_card_show')
    }
  }
}
</script>
